import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { DependencyLicenseListInitialState, DependencyLicenseListLoad } from './dependency-license-list.actions';
import { DependencyLicenseListState, DependencyLicenseListStateModel } from './dependency-license-list.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';

@Injectable({ providedIn: 'root' })
export class DependencyLicenseListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<DependencyLicenseListStateModel> = this.store.select(DependencyLicenseListState.getState);
  loaded$: Observable<boolean> = this.store.select(DependencyLicenseListState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new DependencyLicenseListLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new DependencyLicenseListInitialState());
  }
}
